var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "FeedbackModal", role: "dialog", tabindex: "-1" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _c("img", {
                attrs: {
                  src: require(`../../assets/images/feedback-modal@2x.png`),
                  srcset: `${require(`../../assets/images/feedback-modal@1x.png`)} 1x, ${require(`../../assets/images/feedback-modal@2x.png`)} 2x, ${require(`../../assets/images/feedback-modal@3x.png`)} 3x, ${require(`../../assets/images/feedback-modal@4x.png`)} 4x`,
                },
              }),
              _vm._v(" "),
              !_vm.feedbackManager?.submitted
                ? _c("feedback-form-modal")
                : _vm._e(),
              _vm._v(" "),
              _vm.feedbackManager?.submitted
                ? _c("feedback-sent-modal")
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }